<template>
    <v-app>
        <v-main>
            <div class="page">
                <div class="bg-texture"></div>
                <div class="glow"></div>

                <v-card class="login-card">
                    <div class="d-flex justify-center mb-2">
                        <v-img
                            src="@/assets/logo.png"
                            alt="School Logo"
                            width="140"
                            contain
                            class="flex-grow-0"
                        />
                    </div>

                    <div class="eyebrow">{{ schoolName }}</div>
                    <h1 class="title">Staff Portal</h1>

                    <h3 class="headline mb-4">Change Password</h3>

                    <v-alert :type="alert.type" v-if="alert.show" text prominent icon="mdi-alert-circle-outline" class="mb-8">
                        {{ alert.message }}
                    </v-alert>

                    <v-form @submit.prevent ref="form">
                        <label class="portal-login__field mb-4">
                            <span class="portal-login__field-label primary--text">New Password</span>
                           <v-text-field
                                v-model="formData.password"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"                                                    
                                placeholder="Enter your new password"
                                outlined
                                dense
                                clearable
                                ref="password"
                                color="primary"
                                v-on:keyup="keyPressPassword"
                                hide-details
                            >
                                <v-icon
                                    slot="prepend-inner"
                                    color="primary"
                                    left
                                >
                                    mdi-key
                                </v-icon>
                            </v-text-field>
                        </label>

                        <label class="portal-login__field mb-4">
                            <span class="portal-login__field-label primary--text">Re-Enter Password</span>

                            <v-text-field
                                v-model="formData.confirmPassword"
                                :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showConfirm ? 'text' : 'password'"
                                @click:append="showConfirm = !showConfirm"                                                    
                                placeholder="Re-enter your new password"
                                outlined
                                dense
                                clearable
                                ref="password"
                                color="primary"
                                v-on:keyup="keyPressPassword"
                                hide-details
                            >
                                <v-icon
                                    slot="prepend-inner"
                                    color="primary"
                                    left
                                >
                                    mdi-key
                                </v-icon>
                            </v-text-field>
                        </label>
                       
                
                        <div class="text-right mt-6  mb-4">
                            <v-btn 
                                color="primary"
                                @click="changePassword" 
                                dark
                                block
                             >
                                LOGIN
                             </v-btn>
                        </div>
                    </v-form>
                </v-card>

                <v-overlay
                    :value="overlay"
                    opacity="0.8"
                    z-index="15"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
            </div>
        </v-main>
    </v-app>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'LoginTermReports',
    components: {
        //
    },
    data: () => ({
        formData: {
            password: '', 
            confirmPassword: '',           
        },
        show: false, 
        showConfirm: false,       
        password: true,
        alert:{
            show: false,
            message: '',
            type: 'error'
        },
        overlay: false,
    }),
    computed: {
        ...mapGetters({            
            schoolName: 'app/getSchoolName', 
        }),        
        
    },
    methods: {
        ...mapActions({
           postNewPassword: 'auth/changePassword',   
        }),

        ...mapMutations({
            setNewPassword: 'auth/setNewPassword',       
        }),
       
        async changePassword(){
            //console.log(this.formData);
            if(!this.formData.password || !this.formData.confirmPassword){
                console.log('passwords are blank');
                this.alert.message = 'Please enter a password';
                this.alert.show = true;
                return;
            }

            if(this.formData.password != this.formData.confirmPassword){
                console.log('passwords dont match');
                this.alert.message = 'Passwords do not match';
                this.alert.show = true;
                return;
            }

            console.log('changing password...');
            this.setNewPassword(this.formData.confirmPassword);
            try {
                await this.postNewPassword();
                this.$router.replace('/app');
            } catch (error) {
                console.log(error);
            }
            
        },
        
        keyPress (e) {
            if(e.keyCode === 13){
                this.$refs.password.focus();
            }
        },

        keyPressPassword (e) {
            if(e.keyCode === 13){
                this.submit();
            }
        }
        
    },
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
  background: #faf6ef;
}

/* background pattern */
.bg-texture {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(27,33,66,0.05) 1px, transparent 1px);
  background-size: 28px 28px;
  opacity: 0.6;
}

/* glow effect */
.glow {
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(201,152,47,0.18), transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* card */
.login-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 420px;
  padding: 40px;
  border-radius: 24px;
  border: 1px solid rgba(27,33,66,0.06);
}

/* logo */
.logo-wrap {
  text-align: center;
  margin-bottom: 24px;
}

/* small heading */
.eyebrow {
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  color: #716c62;
  margin-bottom: 8px;
}

/* title */
.title {
  text-align: center;
  margin: 0 0 32px;
  font-family: 'Fraunces', serif;
  font-size: 34px;
  color: #1B2142;
}


/* button */
.login-btn {
  background: linear-gradient(135deg, var(--v-primary-base), var(--v-primary-lighten1));
  color: white;
  font-weight: 600;
  border-radius: 14px;
}

/* back link */
.back-link {
  display: block;
  text-align: center;
  margin-top: 20px;
  color: #2C3568;
  text-decoration: none;
  font-size: 14px;
}

.portal-login__field {
display: flex;
flex-direction: column;
gap: 6px;
}

.portal-login__field-label {
font-size: 11.5px;
letter-spacing: 0.04em;
color: rgba(245, 241, 230, 0.6);
text-transform: uppercase;
}
</style>